import React from 'react';
import Icon from 'components/AppIcon';

export default function SummaryStats({ stats, loading }) {
  const monthlyBudget = stats?.monthlyBudget || 0;
  const totalSpent = stats?.totalSpent || 0;
  const remaining = stats?.remaining || 0;
  const totalSavings = stats?.totalSavings || 0;
  const spentPct = monthlyBudget > 0 ? ((totalSpent / monthlyBudget) * 100)?.toFixed(1) : '0.0';

  const statItems = [
    {
      label: 'Monthly Budget',
      value: loading ? '—' : `$${monthlyBudget?.toLocaleString()}`,
      sub: stats?.monthYear ? new Date(stats.monthYear + '-01')?.toLocaleString('default', { month: 'long', year: 'numeric' }) : '—',
      icon: 'Wallet',
      color: '#06B6D4',
      bg: 'rgba(6,182,212,0.1)',
      trend: null,
    },
    {
      label: 'Total Spent',
      value: loading ? '—' : `$${totalSpent?.toLocaleString(undefined, { maximumFractionDigits: 0 })}`,
      sub: loading ? '—' : `${spentPct}% of budget`,
      icon: 'TrendingDown',
      color: '#F59E0B',
      bg: 'rgba(245,158,11,0.1)',
      trend: null,
    },
    {
      label: 'Remaining',
      value: loading ? '—' : `$${Math.abs(remaining)?.toLocaleString(undefined, { maximumFractionDigits: 0 })}`,
      sub: remaining >= 0 ? 'available' : 'over budget',
      icon: 'PiggyBank',
      color: remaining >= 0 ? '#10B981' : '#EF4444',
      bg: remaining >= 0 ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)',
      trend: null,
    },
    {
      label: 'Total Savings',
      value: loading ? '—' : `$${totalSavings?.toLocaleString(undefined, { maximumFractionDigits: 0 })}`,
      sub: 'Across all goals',
      icon: 'Target',
      color: '#7C3AED',
      bg: 'rgba(124,58,237,0.1)',
      trend: null,
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {statItems?.map((stat) => (
        <div
          key={stat?.label}
          className="bg-[#0F172A] border border-[rgba(6,182,212,0.1)] rounded-xl p-4 md:p-5 hover:border-[rgba(6,182,212,0.2)] transition-all duration-250"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: stat?.bg }}>
              <Icon name={stat?.icon} size={20} color={stat?.color} />
            </div>
          </div>
          {loading ? (
            <div className="space-y-2">
              <div className="h-6 w-24 bg-[#1E3A5F] rounded animate-pulse" />
              <div className="h-3 w-16 bg-[#1E3A5F] rounded animate-pulse" />
            </div>
          ) : (
            <>
              <p className="font-data text-xl md:text-2xl font-semibold text-[#F8FAFC] mb-0.5">{stat?.value}</p>
              <p className="font-heading font-medium text-xs md:text-sm text-[#94A3B8]">{stat?.label}</p>
              <p className="text-xs text-[#475569] mt-0.5">{stat?.sub}</p>
            </>
          )}
        </div>
      ))}
    </div>
  );
}